import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';

const Stat = ({ label, value }) => (
  <div className="border border-sans_line bg-white p-6">
    <div className="sans-label mb-2">{label}</div>
    <div className="font-serif text-3xl text-sans_ink tabular-nums">{value}</div>
  </div>
);

const AdminHome = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/admin/overview').then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="text-sans_mute">Loading…</div>;
  const c = data.counts, r = data.revenue;

  return (
    <div>
      <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Overview</h1>
      <p className="text-sans_mute mt-2">Everything at a glance.</p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
        <Stat label="Users" value={c.users} />
        <Stat label="Products" value={c.products} />
        <Stat label="Appointments" value={c.appointments} />
        <Stat label="Orders" value={c.orders} />
        <Stat label="Assessments" value={c.assessments} />
      </div>

      <div className="mt-6 grid md:grid-cols-2 gap-4">
        <Stat label="Order revenue" value={`₹${r.orders.toLocaleString()}`} />
        <Stat label="Consultation revenue" value={`₹${r.consultations.toLocaleString()}`} />
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <div className="border border-sans_line bg-white p-6">
          <div className="sans-label mb-4">Recent orders</div>
          {data.recent_orders?.length === 0 && <div className="text-sm text-sans_mute">None in the last 30 days.</div>}
          <div className="space-y-3">
            {data.recent_orders?.map((o) => (
              <div key={o.order_id} className="flex justify-between text-sm">
                <span className="text-sans_ink">{o.order_id}</span>
                <span className="text-sans_mute">₹{o.total} · {o.status}</span>
              </div>
            ))}
          </div>
          <Link to="/admin/orders" className="mt-4 inline-block text-xs text-sans_ink border-b border-sans_ink pb-0.5">View all →</Link>
        </div>
        <div className="border border-sans_line bg-white p-6">
          <div className="sans-label mb-4">Recent appointments</div>
          {data.recent_appointments?.length === 0 && <div className="text-sm text-sans_mute">None in the last 30 days.</div>}
          <div className="space-y-3">
            {data.recent_appointments?.map((a) => (
              <div key={a.appointment_id} className="flex justify-between text-sm">
                <span className="text-sans_ink">{a.user_name}</span>
                <span className="text-sans_mute">{new Date(a.slot_datetime).toLocaleDateString('en-IN')} · {a.status}</span>
              </div>
            ))}
          </div>
          <Link to="/admin/appointments" className="mt-4 inline-block text-xs text-sans_ink border-b border-sans_ink pb-0.5">View all →</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
